const AddItemsManually = () => {
  return (
    <div className="flex justify-between mt-[34.93px] font-instrument">
      <div className="flex items-center">
        <div className="relative flex items-center">
          {/* Large purple circle (left) */}
          <button
            type="button"
            aria-label="Add items"
            className="w-[57.45px] h-[57.45px] rounded-full bg-[#34318C] flex items-center justify-center shadow-lg z-10"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-9 h-9 text-white"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
          </button>

          {/* Middle circle - overlapping */}
          <div className="w-[57.45px] h-[57.45px] rounded-full bg-[#C8C6DF] flex items-center justify-center shadow-sm -ml-[17px] z-1">
            <img
              src="/images/NewUiIcons/vector1.svg"
              alt="vector1"
              className="w-7 h-7"
              style={{ color: "#7876A1" }}
            />
          </div>

          {/* Right circle - further overlapping */}
          <div className="w-[57.45px] h-[57.45px] rounded-full bg-[#E0DEF1] flex items-center justify-center shadow-sm -ml-[17px] z-[0]">
            <img
              src="/images/NewUiIcons/Vector.svg"
              alt="vector-right"
              className="w-7 h-7"
              style={{ color: "#7876A1" }}
            />
          </div>
        </div>

        <span className="block ml-3 min-361:hidden sm:inline text-[14px] font-semibold">
          Add items
        </span>

        {/* Text content - adjusted spacing */}
        <div className="ml-[13px]  self-end max-360:self-center hidden min-361:block">
          {/* Main heading - shows "Add Items" on small screens, full text on larger */}
          <p className="text-sm font-semibold font-instrument text-[#211F59]">
            {/* Show abbreviated text on small screens */}
            <span className="text-[14px] font-semibold">Add items manually</span>
          </p>

          {/* Subtext - hidden on small screens, shown on larger */}
          <p className="text-[12px] text-[#211F59] font-[400] tracking-normal font-instrument opacity-80 mt-1 whitespace-nowrap overflow-hidden overflow-ellipsis">
            No photos? Add items manually.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddItemsManually;
